import dayjs from "dayjs";
import {
  isNowBeforeTime,
  convertTz,
  getDateTimeDate,
  formatAndAddDaysToDateWithIntl,
} from "./timeHelpers";
import { DAILY, MONTHLY, WEEKLY } from "../components/cohort/cohorts.constants";

import DayJSUtc from "dayjs/plugin/utc";
import DayJSTimezone from "dayjs/plugin/timezone";

dayjs.extend(DayJSUtc);
dayjs.extend(DayJSTimezone);

export const reshapedAppointments = (data, user) => {
  return data.map((itm) => {
    const fromMe = itm.host_id === user?._id;

    let offSet = itm.timezone || null;
    let newStartTime = convertTz(itm.start_time, offSet);
    let newEndTime = convertTz(itm.end_time, offSet);

    let appt = {
      ...itm,
      start_time: newStartTime,
      end_time: newEndTime,
      meetingPartner: !fromMe ? itm.host_user : itm.guest_user,
    };
    return appt;
  });
};

export const generateCohortScheduleData = (data, user) => {
  let result = [];
  data.map((item) => {
    if (item.frequency === "once") {
      result.push({
        ...item,
        start_time: item.schedules?.[0]?.start_time,
        end_time: item.schedules?.[0]?.end_time,
        item_type: "cohort",
      });
    } else if (item.frequency === DAILY) {
      const duration = dayjs(item.end_date).diff(dayjs(item.start_date), "day");
      for (let index = 0; index <= duration; index++) {
        const date = dayjs(getDateTimeDate(item.start_date))
          .add(index, "days")
          .format("YYYY-MM-DD");

        // const date = formatAndAddDaysToDateWithIntl(item.start_date, index);

        result.push({
          ...item,
          item_type: "cohort",
          start_date: date,
          end_date: date,
          start_time: item.schedules[0]?.start_time,
          end_time: item.schedules[0]?.end_time,
          guest_id: user._id === item.user_id ? item.user_id : "",
        });
      }
    } else if (item.frequency === WEEKLY) {
      let dates = [];
      const duration = dayjs(item.end_date).diff(
        dayjs(item.start_date),
        "weeks"
      );

      for (let index = 0; index < item.schedules.length; index++) {
        const currItem = item.schedules[index];
        const dayIndex = currItem.day_of_week;
        let currentDate = dayjs(getDateTimeDate(item.start_date))
          .startOf("week")
          .day(dayIndex);
        if (!currentDate) return;
        // Iterate through the next 6 weeks
        for (let i = 0; i < duration; i++) {
          dates.push({
            date: currentDate?.format("YYYY-MM-DD"),
            start_time: currItem.start_time,
            end_time: currItem.end_time,
            item_type: "cohort",
          });
          currentDate = currentDate?.add(1, "week"); // Move to the next week
        }
      }

      dates.forEach((date) => {
        result.push({
          ...item,
          item_type: "cohort",
          start_date: date.date,
          end_date: date.date,
          start_time: date.start_time,
          end_time: date.end_time,
          guest_id: user._id === item.user_id ? item.user_id : "",
        });
      });
    } else if (item.frequency === MONTHLY) {
      for (let index = 0; index < item.schedules.length; index++) {
        const currItem = item.schedules[index];
        const date = dayjs(currItem.date).format("YYYY-MM-DD");
        result.push({
          ...item,
          item_type: "cohort",
          start_date: date,
          end_date: date,
          start_time: currItem?.start_time,
          end_time: currItem?.end_time,
          guest_id: user._id === item.user_id ? item.user_id : "",
        });
      }
    }
  });
  return result;
};

export const getUpcomingAppointments = (myAppointments = []) => {
  let appointmentByDate = [...myAppointments]
    .sort((a, b) => {
      const dateA = dayjs(getDateTimeDate(getDateTimeDate(a?.start_date)));
      const dateB = dayjs(getDateTimeDate(getDateTimeDate(b?.start_date)));
      if (dateA.isSame(dateB.format("YYYY-MM-DD"))) {
        if (a.start_time < b.start_time) return -1;
        if (a.start_time > b.start_time) return 1;
      }
      if (dateA.isBefore(dateB.format("YYYY-MM-DD"))) return -1;
      if (dateA.isAfter(dateB.format("YYYY-MM-DD"))) return 1;
      return 0;
    })
    .filter((a) => {
      const startDate = getDateTimeDate(a?.start_date);
      const isAhead = dayjs(startDate).isAfter(dayjs().format("YYYY-MM-DD"));
      const isSameDay = dayjs(startDate).isSame(dayjs().format("YYYY-MM-DD"));
      let now = dayjs().format("HH:mm:ss");
      let meetingEnd = a.end_time;
      const meetingEndAfterNow = isNowBeforeTime(now, meetingEnd);
      return isAhead || (isSameDay && meetingEndAfterNow);
    });

  return appointmentByDate.filter(
    (e) => e.item_type === "cohort" || e.status === "accepted"
  );
};

export const myTimeZone = new Date().toString().match(/([A-Z]+[\+-][0-9]+)/)[1];

export const sortDataByDate = (data) => {
  if (!Array.isArray(data)) {
    return data;
  }
  return [...data]?.sort((a, b) => {
    const dateA = dayjs(getDateTimeDate(a?.start_date));
    const dateB = dayjs(getDateTimeDate(b?.start_date));
    if (dateA.isSame(dateB.format("YYYY-MM-DD"))) {
      if (a.start_time < b.start_time) return -1;
      if (a.start_time > b.start_time) return 1;
    }
    if (dateA.isBefore(dateB.format("YYYY-MM-DD"))) return -1;
    if (dateA.isAfter(dateB.format("YYYY-MM-DD"))) return 1;
    return 0;
  });
};
